import { records, utils } from '@ims/1edtech-frontend-common'
import * as R from 'ramda'

import { ORGANIZATIONS_RECORD } from 'lib/records/modules/organizations'
import { USER_PREFERENCES_RECORD } from 'lib/records/modules/userPreferences'
import { getRecord } from 'lib/records/workflows/getRecord'
import store from 'lib/store'
import { setApplicationProperties } from 'domains/application/ducks/application'
import trackSessionAnalytics, {
  setUserProperties,
} from 'domains/application/utils/trackSessionAnalytics'
import {
  ORG_TYPE_TO_ROLE_MAP,
  ROLE_TYPES,
} from 'domains/authentication/constants/roles'
import { meSelector } from 'domains/authentication/selectors/me'
import {
  myOrganizationIdSelector,
  myOrganizationPropSelector,
} from 'domains/authentication/selectors/organizations'
import { myNotificationPreferenceSelector } from 'domains/notifications/selectors/notificationSelectors'
import {
  cancelNotificationListener,
  listenForNotifications,
} from 'domains/notifications/workflows/listenForNotifications'

export const getUserProperties = (user: any, org: any = {}) => ({
  id: R.prop('id', user),
  firstName: R.prop('firstName', user),
  lastName: R.prop('lastName', user),
  jobTitle: R.prop('jobTitle', user),
  environment: utils.host.getHostname(),
  orgId: R.prop('id', org),
  orgName: R.prop('name', org),
  orgType: R.prop('type', org),
  orgReferrerId: R.prop('referrerId', org),
  orgMembershipLevel: R.prop('membershipLevel', org),
  orgAdmin: R.propOr(false, 'admin', user),
  ims: R.prop('ims', user),
})

export const whoAmI = async (): Promise<boolean | ROLE_TYPES> => {
  cancelNotificationListener()

  const me = meSelector(store.getState())

  if (!me) return false

  const orgId = me.organization.id

  await getRecord(USER_PREFERENCES_RECORD, utils.convertToInt(me.id))
  const myNotificationPref = myNotificationPreferenceSelector(store.getState())
  listenForNotifications(myNotificationPref)
  await getRecord(ORGANIZATIONS_RECORD, orgId)
  const orgType = myOrganizationPropSelector('type')(store.getState(), {})
  const role = ORG_TYPE_TO_ROLE_MAP[orgType as string]
  store.dispatch(setApplicationProperties({ role }))
  const user = meSelector(store.getState())
  const org = records.entitiesSelectors.entityByIdSelector(
    ORGANIZATIONS_RECORD,
    myOrganizationIdSelector,
  )(store.getState())
  const userProperties = getUserProperties(user, org)
  trackSessionAnalytics('started_session', userProperties)
  setUserProperties(userProperties)

  return role
}
